import React from 'react';
import './ZoomDisplay.css';

interface ZoomDisplayProps {
  zoom: number;
}

const ZoomDisplay: React.FC<ZoomDisplayProps> = ({ zoom }) => {
  return (
    <div className="zoom-display">
      Z{Math.round(zoom)}
    </div>
  );
};

export default ZoomDisplay;